// Balcão: todas as categorias numa grade só. Clicar na categoria ROLA até ela
// (pedido do dono, 29/09/2026: "não deve filtrar, só rolar até a categoria") e
// a categoria que está no alto acende sozinha conforme a rolagem.
import { useCallback, useRef, useState } from "react";

const TRAVA_APOS_CLIQUE_MS = 700; // a rolagem suave passa pelas outras seções

export function useRolagemCategorias() {
  const containerRef = useRef(null);
  const secoes = useRef({});
  const travaAte = useRef(0);
  const [ativa, setAtiva] = useState(null);

  const registrarSecao = useCallback((nome) => (el) => {
    if (el) secoes.current[nome] = el;
    else delete secoes.current[nome];
  }, []);

  const rolarPara = (nome) => {
    const container = containerRef.current;
    const secao = secoes.current[nome];
    if (!container || !secao) return;
    setAtiva(nome);
    travaAte.current = Date.now() + TRAVA_APOS_CLIQUE_MS;
    container.scrollTo({ top: secao.offsetTop, behavior: "smooth" });
  };

  // A seção ativa é a última cujo topo já passou do alto da grade.
  const aoRolar = () => {
    const container = containerRef.current;
    if (!container || Date.now() < travaAte.current) return;
    let atual = null;
    for (const [nome, el] of Object.entries(secoes.current)) {
      if (el.offsetTop - container.scrollTop <= 8 && (!atual || el.offsetTop > secoes.current[atual].offsetTop)) atual = nome;
    }
    if (atual && atual !== ativa) setAtiva(atual);
  };

  return { containerRef, registrarSecao, rolarPara, aoRolar, ativa };
}
